// export const CURRENT_BOOK = "CURRENT_BOOK";
// export const CURRENT_ARTICLE = "CURRENT_ARTICLE";
// export const CURRENT_EVENT = "CURRENT_EVENT";
export const IS_WELCOME_PAGE = "IS_WELCOME_PAGE";
export const AUTH_INFO = "AUTH_INFO";
export const LANG = "LANG";
export const USER_TOKEN = "USER_TOKEN";
export const I18N = "I18N";
export const NEWNOTICE = "NEWNOTICE";
export const HANDLENOTICE = "HANDLENOTICE";
// export const BOOKLIST = "BOOKLIST";
// export const EVENTLIST = "EVENTLIST";
// export const COMMENTLIST = "COMMENTLIST";
// export const NEWBOOK = "NEWBOOK";
// export const NEWARTICLE = "NEWARTICLE";
// export const UPDATEBOOK = "UPDATEBOOK";
// export const UPDATEARTICLE = "UPDATEARTICLE";
// export const NEWCOMMENT = "NEWCOMMENT";
// export const DELARTICLE = "DELARTICLE";
// export const NEWPUBLICBOOK = "NEWPUBLICBOOK";
// export const PREVROUTE = "PREVROUTE";
// export const PUBLICBOOKLIST = "PUBLICBOOKLIST"
// export const CREATEDBOOKLIST = "CREATEDBOOKLIST"
// export const JOINEDBOOKLIST = "JOINEDBOOKLIST"
// export const ARTICLELIST = "ARTICLELIST";
// export const FAVEDBOOKLIST = 'FAVEDBOOKLIST'
